import React from "react";
import { Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import {
  COMPANY_PROMOTION_FEATURED_LOGO,
  PROMOTION_SERVICE_TYPE,
} from "../employerConstanst";
import PromotionServicesList from "./PromotionServicesList";
import {
  isItemExpired,
  isItemForListing,
} from "../../jobs/helpers/compareJobDates";
import useFirestoreCollection from "../../../app/hooks/useFirestoreCollection";
import {
  listenEmployerFreeCompanyFeaturedLogos,
  listenEmployerPaidCompanyFeaturedLogos,
} from "../../../app/firestore/firestoreService";
import {
  fetchEmployerFreeCompanyFeaturedLogos,
  fetchEmployerPaidCompanyFeaturedLogos,
} from "../employerActions";
import { QUERY_CODES } from "../../../app/firestore/firestoreConstants";
import { UnderReviewInfo } from "./ManageJobPosts";

export default function ManagePromotionServices({
  isAdmin = false,
  companyId = null,
}) {
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.async);
  const { currentUserAccount } = useSelector((state) => state.account);
  const { companyFeaturedLogos, freebies } = useSelector(
    (state) => state.employer
  );
  const { responsive } = useSelector((state) => state.app);

  useFirestoreCollection({
    shouldExecute:
      currentUserAccount.id !== null && isAdmin && companyId !== null,
    query: () => listenEmployerPaidCompanyFeaturedLogos(companyId),
    data: (logos) => dispatch(fetchEmployerPaidCompanyFeaturedLogos(logos)),
    deps: [dispatch, currentUserAccount.id, companyId],
    queryCode: QUERY_CODES.listenToEmployerPaidJobsFromFirestore,
  });

  useFirestoreCollection({
    shouldExecute:
      currentUserAccount.id !== null && isAdmin && companyId !== null,
    query: () => listenEmployerFreeCompanyFeaturedLogos(companyId),
    data: (logos) => dispatch(fetchEmployerFreeCompanyFeaturedLogos(logos)),
    deps: [dispatch, currentUserAccount.id, companyId],
    queryCode: QUERY_CODES.listenEmployerFreeCompanyFeaturedLogos,
  });

  function isLogoUnderReview(logo) {
    return !logo.isApproved && !logo.dateExpiring;
  }

  const logos = [...companyFeaturedLogos, ...freebies.companyFeaturedLogos];

  return (
    <Grid>
      <Grid.Row style={{ margin: "35px 0 60px 0" }}>
        <Grid.Column computer={15} tablet={16} mobile={16}>
          <div className={"manage-items"}>
            <PromotionServicesList
              promotionType={PROMOTION_SERVICE_TYPE.underReview}
              promotions={logos.filter((logo) => isLogoUnderReview(logo))}
              promotionItemType={COMPANY_PROMOTION_FEATURED_LOGO}
              heading={<UnderReviewInfo responsive={responsive} />}
              noPromotionsHeading="You have no promotions under review"
              isAdmin={isAdmin}
              loading={loading}
            />
            <PromotionServicesList
              promotionType={PROMOTION_SERVICE_TYPE.active}
              promotions={logos.filter((logo) => isItemForListing(logo))}
              promotionItemType={COMPANY_PROMOTION_FEATURED_LOGO}
              heading="Active"
              noPromotionsHeading="You have no active promotions"
              isAdmin={isAdmin}
              loading={loading}
            />
            <PromotionServicesList
              promotionType={PROMOTION_SERVICE_TYPE.expired}
              promotions={logos.filter((logo) => isItemExpired(logo))}
              promotionItemType={COMPANY_PROMOTION_FEATURED_LOGO}
              heading="Expired"
              noPromotionsHeading="You have no expired promotions"
              isAdmin={isAdmin}
              loading={loading}
            />
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
